import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { Routes } from '../../../../common/enums/Routes';

interface IProps {
  name: string;
  icon: FunctionComponent;
}

const DashboardTab: FunctionComponent<IProps & RouteComponentProps> = ({
  name,
  icon: Icon,
  location
}) => (
  <div className="tab">
    <NavLink
      className={`tab-link ${location.pathname.includes(name) ? 'active' : ''}`}
      to={`${Routes.Dashboard}/${name}`}
    >
      <Icon />
      <FormattedMessage id={`dashboard.${name}`} defaultMessage={name} />
    </NavLink>
  </div>
);

export default withRouter(DashboardTab);
